import { NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { Message } from "primeng/message";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { UnsubscribeService } from "./unsubscribe.service";

@Component({
  selector: "new-ui-unsubscribe",
  templateUrl: "./new-ui-unsubscribe.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiButton, Message, NgOptimizedImage, RouterLink],
})
export class NewUiUnsubscribeComponent {
  showSuccess = false;

  constructor(private readonly service: UnsubscribeService) {}

  onUnsubscribe(): void {
    this.showSuccess = true;
    this.service.resolveUnsubscribe().subscribe(() => ({}));
  }
}
